module.exports = __webpack_public_path__ + "img/icon_logo.31bbbb68.png";